module.exports = __webpack_public_path__ + "c6460c295facb2e5abbc3ee7ae445f6f.pdf";